module.exports = __webpack_public_path__ + "static/img/partner1.dbdb0c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/partner1.png
// module id = lyHI
// module chunks = 0